import { sendRequest } from "./api";

interface ICalendarItem {

}

const route = 'calendar';

export const getCalendarItems = () => {
    return sendRequest(route, 'GET', undefined, '');
}

// Transform calendar item to server format with Datetime field
const calendarItemToServer = (item: any) => {
    const result = { ...item };
    
    // Convert start date to UTC timestamp (Datetime field) if present
    if (item.start) {
        try {
            const startDate = item.start instanceof Date ? item.start : new Date(item.start);
            if (!isNaN(startDate.getTime())) {
                result.Datetime = Math.floor(startDate.valueOf() / 1000);
            }
        } catch (e) {
            console.warn('Failed to convert calendar item start date to UTC timestamp:', e);
        }
    }
    
    // Clean up client-only fields - keep editOtherEvents as backend expects it
    delete result.start;
    delete result.end;
    
    return result;
};

export const postCalendarItem = (item: ICalendarItem) => {
    return sendRequest(route, 'POST', calendarItemToServer(item), '');
}

export const getCalendarItem = (itemId: string) => {
    return sendRequest(route + '/', 'GET', undefined, itemId);
}

export const putCalendarItem = (item: ICalendarItem, itemId: string, editOtherEvents: boolean = false) => {
    const requestData = {...calendarItemToServer(item), "editOtherEvents": editOtherEvents};
    return sendRequest(route + '/', 'PUT', requestData, itemId);
}

export const deleteCalendarItem = (itemId: string, all: boolean) => {
    return sendRequest(route + '/', 'DELETE', {
        action: all ? 'delete-all' : 'delete-single',
        includeThis: true,
        amount: 0
    }, itemId);
}

